import { defineStore } from 'pinia'
import THEMES from '@/themes/config'
import {
  createObjfromStr,
  lowPriorityAsyncCall,
  saveUserNameAndPassword,
} from '@/utils'
import { ev } from '@/consts'
import * as api from '@/api'
import { USERINFO_KEY } from '@/consts'
import { SYSTEM_ACTIVITY_LIST, ACTIVITY_DATA } from '@/consts'
import {
  params,
  isInIframe,
  isTemplate,
  isInPWA,
  isIOS,
  isInAndroidApp,
} from '@/env'
import { eShowType, eCategoryIcon } from '@/types/index'
import { addTrackPrams } from '@/api/request'
import type {
  iUserInfo,
  iWallet,
  tCurrency,
  tLang,
  tTheme,
  iGameCategory,
  iGame,
  iRoom,
  tActivityType,
  iActivity,
  // iPromocaoItem,
  iHomeBannersAndTexts,
  iServicoItem,
  iMerchantConfig,
  iUpdateConfig,
  // iUserDetail,
} from '@/types/index'
import useLoadPreload from '@/hooks/useLoadPreload'

export const useUserInfo = defineStore(
  'userInfo',
  () => {
    const userInfo = ref<iUserInfo | null>(null)

    const updateUserInfo = async (info?: Partial<iUserInfo>) => {
      if (userInfo.value) Object.assign(userInfo.value, info)
    }

    const updateUserDetail = async (times = 15000) => {
      const { code, data } = await api.getUserDetail(times)
      if (code === 1 && data) {
        Object.keys(data).forEach((key) => {
          userInfo.value![key] = data[key]
        })
      }
    }

    const isLoggedin = computed(
      () => !!userInfo.value?.token && !!userInfo.value?.userid,
    )

    const login = async (info: iUserInfo, token: string, isRestore = false) => {
      if (!info || !token) {
        console.warn('login failed, info or token is null')
        return
      }

      const _repeated = info.userid && userInfo.value?.userid === info.userid
      if (!isRestore && _repeated && userInfo.value) {
        userInfo.value.token = token
      } else {
        userInfo.value = info
        userInfo.value.token = token
        await Promise.all([updateUserDetail(), useAppPwa().init()])
        ev.emit('login', isRestore)
      }
    }

    const logout = () => {
      if (!isLoggedin.value) return

      userInfo.value = null

      setTimeout(() => {
        delete localStorage[USERINFO_KEY]
      }, 10)

      ev.emit('logout')
    }

    // 刷新Token，用于给外层存储登录信息
    const refreshToken = async (oldToken: string) => {
      // console.log("refreshToken-->oldToken", oldToken)
      // console.log("refreshToken-->import.meta.env.VITE_BASE_URL", import.meta.env.VITE_BASE_URL)
      // console.log("refreshToken-->userInfo.token", userInfo.value?.token)
      try {
        const headers = {
          'Access-Control-Allow-Origin': '*',
          'Content-Type': 'application/json',
          Authorization: oldToken,
          'cache-control': 'no-cache',
        }
        addTrackPrams(headers)

        const response = await fetch(
          `${import.meta.env.VITE_BASE_URL}carbon-auth/private/user/center/token/refresh`,
          {
            method: 'GET',
            headers: headers,
          },
        )
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        const resp = await response.json()
        console.log('refreshToken-->resp', resp)
        return resp.data
      } catch (error) {
        console.error('Error during fetch:', error)
        return null
      }
    }

    const _loginFrom = async (text: string, from: string = 'no source') => {
      if (text) {
        try {
          const info = createObjfromStr(
            decodeURIComponent(atob(text)),
          ) as iUserInfo
          //  _loginFrom->从外部登录的时候，保存用户名和密码
          console.log('_loginFrom->从外部登录的时候，保存用户名和密码')
          console.log('info->', info)
          saveUserNameAndPassword(info.un_flag, info.ps_flag, true)
          // Inner: PWA带防封的时候，appLogin：安卓APP登录的时候
          if (from === 'Inner' || from === 'appLogin' || (isIOS && isInPWA)) {
            console.log('这是_loginFrom->刷新token')
            // 判断如果token已经刷新过了，就不再刷新了`
            if (!localStorage.getItem('tokenRefreshed')) {
              console.log(
                'tokenRefreshed',
                localStorage.getItem('tokenRefreshed'),
              )
              localStorage.setItem('tokenRefreshed', '1')
            } else {
              return
            }

            //如果是内层，才刷新token，然后内层会传给外层保存，这样每次内层登录的时候会从外层读取登录token
            const newToken = await refreshToken(info.token)
            // console.log("_loginFrom-->refreshToken-->newToken", newToken)
            login(info, newToken)
            // console.log("_loginFrom-->refreshToken-->login-->from:", from)
          } else {
            login(info, info.token)
          }
        } catch (e) {
          console.error('loginFrom error', e)
        }
      }
    }

    window.loginFrom = (infoStr: string) => {
      // if (localStorage.getItem('loginFrom') != '1') {
      // 只恢复一次
      _loginFrom(infoStr, 'appLogin')
      // localStorage.setItem('loginFrom', '1')
      // }
    }

    const checkToLogin = async (times = 1, interval = 200) => {
      // console.log("这是checkToLogin,", times)
      if (times <= 0) return
      // console.log("checkToLogin-->isLoggedin.value", isLoggedin.value, "isInIframe", isInIframe)
      if (isLoggedin.value && !isInIframe) return
      // console.log("checkToLogin-->isLoggedin.value", isLoggedin.value, "isInIframe", isInIframe)
      // 如果是在谷歌模板安装页面不用走这个
      if (isTemplate && !isInPWA) return
      // console.log("checkToLogin-->isTemplate", isTemplate, "isInPWA", isInPWA)
      // 如果是在安卓APP中，不用走这个
      if (isInAndroidApp) {
        const cpbt = window.jsBridge.postMessage('getClipboardText', '')
        if (typeof cpbt === 'string' && cpbt.startsWith('info=')) {
          _loginFrom(cpbt, 'appLogin')
        }
        return
      }

      const infoStr = params.get('info')
      if (infoStr) {
        if (isInIframe) {
          // 内层
          console.log('这是isInIframe->Inner的登录逻辑')
          _loginFrom(infoStr, 'Inner')
        } else {
          // 外层
          console.log('这是isInIframe->Outer的登录逻辑')
          // const _info = localStorage.getItem('_info')
          // if (!_info) {
          const userInfoFromLocalStorage = localStorage.getItem(USERINFO_KEY)
          if (!userInfoFromLocalStorage) {
            console.log('这是isInIframe->Outer的登录逻辑->没有用户信息')
            _loginFrom(infoStr, 'Outer')
          }
          // localStorage.setItem('_info', '1')
          // }
        }
      } else {
        if (isInIframe) {
          // 内层状态要跟随外层
          // setTimeout(() => {
          //   useUserInfo().logout()
          // }, 300)
        } else {
          // 外层从local恢复状态
          const infoStr = localStorage.getItem(USERINFO_KEY)
          if (infoStr) {
            try {
              const info = JSON.parse(infoStr).userInfo
              if (info.token) {
                login(info, info.token)
              }
            } catch (e) {}
          }
        }
      }

      setTimeout(() => {
        checkToLogin(times - 1, interval)
      }, interval)
    }

    return {
      userInfo,
      updateUserInfo,
      isLoggedin,
      logout,
      login,
      checkToLogin,
      updateUserDetail,
    }
  },
  {
    persist: {
      key: USERINFO_KEY,
    },
  },
)

export const useWallet = defineStore('wallet', () => {
  const wallet = ref<iWallet>({
    firstDepositAmount: 0,
    totalReward: 0,
    totalAgentCommission: 0,
    balance: 0,
  } as iWallet)

  const getWallet = async () => {
    const currency = (useUserInfo().userInfo?.currency as tCurrency) || 'BRL'
    const { code, data } = await api
      .getWallet({ currency })
      .catch(() => ({ code: 0, data: null }))
    if (code === 1 && data) {
      wallet.value = data
    }
  }

  const updateWallet = async (data: Partial<iWallet>) => {
    Object.assign(wallet.value, data)
  }

  const reset = async () => {
    wallet.value = {
      firstDepositAmount: 0,
      totalReward: 0,
      totalAgentCommission: 0,
      balance: 0,
    } as iWallet
  }

  const init = async () => {
    if (useUserInfo().isLoggedin) await getWallet()
    else reset()
  }

  return { wallet, updateWallet, reset, init }
})

export const useSystemInfo = defineStore('systemInfo', () => {
  const isInit = ref(true)
  const theme = ref<tTheme>('')
  const skin = ref<string>('')
  const language = ref<tLang>('pt')
  const languages = ref<tLang[]>(['pt'])
  const langStr = computed(() => {
    const lang = language.value
    if (lang === 'en') return 'en-US'
    if (lang === 'pt') return 'pt-BR'
    return lang
  })

  const imageBaseUrl = ref('')
  const merchantConfig = ref<iMerchantConfig | null>(null)
  const updateConfig = ref<iUpdateConfig | null>(null)

  const init = async () => {
    const preloadManager = useLoadPreload()
    const accessUrl = preloadManager.getPreloadData()?.accessUrl || null
    const merchant = preloadManager.getPreloadData()?.merchant || null
    const WebUpdateVersionInterval =
      preloadManager.getPreloadData()?.WebUpdateVersionInterval || null
    const WebUpdateVersionPopUp = preloadManager.getPreloadData()?.WebUpdateVersionPopUp || null
    if (
      accessUrl &&
      merchant &&
      WebUpdateVersionPopUp &&
      WebUpdateVersionInterval &&
      isInit.value
    ) {
      imageBaseUrl.value = accessUrl
      merchantConfig.value = merchant
      updateConfig.value = {
        WebUpdateVersionPopUp: WebUpdateVersionPopUp,
        WebUpdateVersionInterval: WebUpdateVersionInterval,
      }
    } else {
      const { code, data } = await api
        .getMerchantConfig()
        .catch(() => ({ code: 0, data: null }))

      if (code === 1 && data) {
        imageBaseUrl.value = data.accessUrl
        merchantConfig.value = data.merchant
        updateConfig.value = {
          WebUpdateVersionPopUp: data.WebUpdateVersionPopUp,
          WebUpdateVersionInterval: data.WebUpdateVersionInterval,
        }
      }
    }

    const tpl = (params.get('tpl') || localStorage.getItem('tpl')) as tTheme
    const sk = params.get('skin') || localStorage.getItem('skin')

    if (tpl && sk) {
      console.warn('Using tpl', tpl, 'skin', sk)

      theme.value = tpl in THEMES ? tpl : (THEMES.default as tTheme)
      skin.value =
        sk in THEMES[theme.value].skins ? sk : THEMES[theme.value].skins.default
    } else {
      const t =
        merchantConfig.value && (merchantConfig.value as any).clientTemplate
          ? (merchantConfig.value as any).clientTemplate.toLowerCase()
          : undefined
      if (t && t in THEMES) {
        theme.value = t
      } else {
        console.warn(
          `Theme ${t} not found, using default theme: ${THEMES.default}`,
        )
        theme.value = THEMES.default as tTheme
      }

      const s = merchantConfig.value?.clientSkin?.toLowerCase()
      if (typeof s === 'string' && s in THEMES[theme.value].skins) {
        skin.value = s
      } else {
        console.warn(
          `Skin ${s} not found, using default skin: ${THEMES[theme.value].skins.default}`,
        )
        skin.value = THEMES[theme.value].skins.default
      }
    }

    const lang = params.get('lang') as tLang
    if (lang) {
      language.value = lang
      languages.value = [lang]
    } else {
      // const preferedLang = intersection(usePreferredLanguages().value, data.merchant.languages);
      const preferedLang = (merchantConfig.value?.languages as tLang[]) || []
      if (preferedLang.length) {
        language.value = preferedLang[0]
        languages.value = preferedLang
      } else if ((merchantConfig.value?.languages as tLang[])?.length) {
        language.value = (merchantConfig.value?.languages as tLang[])[0]
        languages.value = merchantConfig.value?.languages as tLang[]
      }
    }
  }

  function setLanguage(val: tLang) {
    language.value = val
  }
  function setIsInit(val: boolean) {
    isInit.value = val
  }

  return {
    theme,
    skin,
    language,
    langStr,
    imageBaseUrl,
    merchantConfig,
    setLanguage,
    init,
    languages,
    updateConfig,
    isInit,
    setIsInit
  }
})

export const useOpenningImage = defineStore('openningImage', () => {
  const openningImage = ref('')

  function updateOpenningImage() {
    openningImage.value = localStorage.getItem('loadingImage') || ''
    const preloadManager = useLoadPreload()
    const preloadData = preloadManager.getPreloadData()
    if (preloadData?.startup?.picture && useSystemInfo().isInit) {
      openningImage.value = preloadData.startup?.picture || ''
    } else {
      lowPriorityAsyncCall(async () => {
        const src = await getOpenningImageFromServer()
        openningImage.value = src
      })
    }
  }

  async function getOpenningImageFromServer() {
    let src = localStorage.getItem('loadingImage') || ''
    const { code, data } = await api
      .getOpening()
      .catch(() => ({ code: 0, data: null }))
    if (code === 1) {
      if (data) {
        src = data.picture
        // if (localStorage.getItem('loadingImage') !== src) {
        //   new Image().src = getImageUrl(src)
        // }
        localStorage.setItem('loadingImage', src)
      } else {
        localStorage.removeItem('loadingImage')
      }
    }

    return src
  }

  const init = async () => {
    await updateOpenningImage()
  }

  return { openningImage, updateOpenningImage, init }
})

export const useGameCategory = defineStore('gameCategory', () => {
  const list = ref<iGameCategory[]>([])

  // 首页那个横条
  const topList = computed(() =>
    list.value.filter(
      (item) =>
        item.showType === eShowType.Top || item.showType === eShowType.All,
    ),
  )

  // 首页分类列表
  const leftList = computed(() =>
    list.value.filter(
      (item) =>
        item.showType === eShowType.Left || item.showType === eShowType.All,
    ),
  )

  // 侧边栏的列表
  const sidebarList = computed(() =>
    list.value.filter((item) => item.showSidebar),
  )

  async function updateGameCategory() {
    const preloadManager = useLoadPreload()
    const preloadData = preloadManager.getPreloadData()
    if (preloadData?.gameCategory && useSystemInfo().isInit) {
      list.value = preloadData.gameCategory.map((item: any) => {
        return {
          ...item,
          defaultIcon:
            eCategoryIcon[item.name as keyof typeof eCategoryIcon]
        }
      })
    } else {
      const { code, data } = await api.getGameCategorys()
      if (code === 1 && data) {
        list.value = data.map((item) => {
          item.defaultIcon =
            eCategoryIcon[item.name as keyof typeof eCategoryIcon]
          return item
        })
      }
    }

  }

  const init = async () => {
    await updateGameCategory()
  }

  return { list, topList, leftList, sidebarList, updateGameCategory, init }
})

export const useFavGamelist = defineStore('favGamelist', () => {
  const list = ref<string[]>([])

  async function updateList() {
    const { code, data } = await api.queryFavoriteGameList()
    if (code === 1 && data) {
      list.value = data
    }
  }

  async function toggleFavorite(isFavorite: boolean, code: string) {
    try {
      if (isFavorite) {
        const { code: deleteCode } = await api.deleteFavoriteGame({ code })
        if (deleteCode === 1)
          list.value = list.value.filter((item) => item !== code)
      } else {
        const { code: createCode } = await api.createFavoriteGame({ code })
        if (createCode === 1) list.value.push(code)
      }
    } catch (e) {
      console.error(e)
    }
  }

  const init = async () => {
    await updateList()
  }

  return { list, updateList, toggleFavorite, init }
})

export const useGame = defineStore('game', () => {
  const list = ref<iGame[]>([])

  async function updateList() {
    const { code, data } = await api.getGameListByCategory({})
    if (code === 1 && data) {
      list.value = data
    }
  }

  const init = async () => {
    await updateList()
  }

  return { list, updateList, init }
})

export const useRoom = defineStore('room', () => {
  const list = ref<iRoom[]>([])

  async function updateRoom() {
    const { code, data } = await api.getRoomList({})
    if (code === 1 && data) {
      list.value = data
    }
  }

  const init = async () => {
    await updateRoom()
  }

  return { list, init, updateRoom }
})

export const useActivity = defineStore('activity', () => {
  const list = ref<iActivity[]>([])
  const listOfType = computed(
    () =>
      (type: tActivityType | 'HOME'): iActivity[] => {
        if (type === 'HOME')
          return list.value.filter((item) =>
            SYSTEM_ACTIVITY_LIST.includes(item.activityType),
          )
        return list.value.filter((item) => item.activityType === type)
      },
  )

  const activityForType = computed(() => (type: tActivityType): iActivity => {
    return (
      list.value.find((item) => item.activityType === type) || ({} as iActivity)
    )
  })

  const updateActivity = async () => {
    let activityList: iActivity[] = []
    try {
      let { code, data } = await api.getActivityDetail({
        activityId: 'All',
      })
      if (code === 1 && data && data.length) {
        activityList = data.map((i: any) => {
          const ret = { ...i } as iActivity
          if (i.activityType === 'CheckIn') {
            ret.configJson = JSON.stringify(ACTIVITY_DATA.CheckIn)
          } else if (i.activityType === 'Task') {
            ret.configJson = JSON.stringify(ACTIVITY_DATA.Task)
          } else if (i.activityType === 'Wheel' && !ret.configJson) {
            ret.configJson = JSON.stringify(ACTIVITY_DATA.Wheel)
          }
          return ret
        })
      }
    } catch (error) {}

    list.value = activityList
  }

  const init = async () => {
    if (!list.value.length) updateActivity()
  }

  return { list, listOfType, activityForType, updateActivity, init }
})

const handleListItem = (li: any) => {
  const { language, theme } = useSystemInfo()
  const themeStr =
    {
      p3: 'theme_a',
      p4: 'theme_b',
    }[theme] || 'theme_a'
  const item = {
    ...ACTIVITY_DATA[li.activityType],
    ...li,
    bannerUrl: li.bannerUrl.replace(
      'local://',
      'local://' + themeStr + '/' + language + '/',
    ),
    showRedPoint: li.rewardStatus === 'Awarded',
  }

  if (SYSTEM_ACTIVITY_LIST.includes(item.activityType)) {
    item.link = '/promocao/' + item.linkName
  } else {
    item.link = '/' + item.linkName
  }

  return item
}

const getPromocaoList = async () => {
  const fn = useUserInfo().isLoggedin
    ? api.getPromocaoList
    : api.getPromocaoListNotLogin
  const { code, data } = await fn({ language: useSystemInfo().language }).catch(
    () => ({ code: 0, data: null }),
  )
  const res: {
    activityList: iActivity[]
    systemList: iActivity[]
    customList: iActivity[]
    typedList: { type: string; configList: iActivity[] }[]
  } = {
    activityList: [],
    systemList: [],
    customList: [],
    typedList: [],
  }

  if (code === 1 && data) {
    res.activityList =
      data.multiple[data.multiple.length - 1]?.configList // .at(-1)
        .map(handleListItem) || []
    res.systemList = data.single
      // .filter((item: any) => item.config?.status === 'Active')
      .map((item: any) => handleListItem(item.config))
    res.typedList = data.multiple.slice(0, -1).map((item: any) => {
      item = {...item}
      item.configList =
        item.configList
          // ?.filter((item: any) => item.status === 'Active')
          .map(handleListItem) || []
      return item
    })

    res.customList = res.typedList.flatMap((item) => item.configList)
  }

  return res
}

const getPromocoLiteList = async () => {
  const { code, data } = await api.getPromocaoLiteList({ language: useSystemInfo().language }).catch(() => ({ code: 0, data: null }))
  const res:{
    activityLiteList: iActivity[]
  } = {
    activityLiteList: []
  }
  if (code === 1 && data) {
    res.activityLiteList = data.multiple[data.multiple.length-1]?.configList.map((item: any) => {
      item.showRedPoint = item.rewardStatus === 'Awarded'
      return item
    }) || []
  }
  return res
}

export const useActivityList = defineStore('activityList', () => {
  const activityList = ref<iActivity[]>([])
  const activityLiteList = ref<iActivity[]>([])
  const systemList = ref<iActivity[]>([])
  const customList = ref<iActivity[]>([])
  const typedList = ref<{ type: string; configList: iActivity[] }[]>([])
  const sidebarList = computed(() =>
    activityList.value.filter((item) => item.locations?.includes('Sidebar')),
  )
  const personalCenterList = computed(() =>
    activityList.value.filter((item) =>
      item.locations?.includes('PersonalCenter'),
    ),
  )
  const updatePromocaoList = async () => {
    const {
      systemList: systemListData,
      customList: customListData,
      typedList: typedListData,
      activityList: activityListData,
    } = await getPromocaoList()

    activityList.value = activityListData
    systemList.value = systemListData
    customList.value = customListData
    typedList.value = typedListData
  }

  const updatePromocoLiteList = async () => {
    const { activityLiteList: activityLiteListData } = await getPromocoLiteList()
    activityLiteList.value = activityLiteListData
  }

  const getActivityById = (id: string) =>
    activityList.value.find((item) => item.activityId === id)

  const init = async () => {
    await updatePromocaoList()
  }

  return {
    activityList,
    activityLiteList,
    systemList,
    customList,
    typedList,
    sidebarList,
    personalCenterList,
    updatePromocaoList,
    updatePromocoLiteList,
    init,
    getActivityById,
  }
})

export const useHomeBannersAndTexts = defineStore('homeBannersAndTexts', () => {
  const config = ref<iHomeBannersAndTexts>({
    suspendIcon: null,
    carouselMessage: [],
    topDownload: null,
    bottomDownload: null,
    bottomText: null,
    bigBanner: [],
    smallBanner: [],
    popupImage: [],
    socialMedia: [],
    webTitle: '',
    webDescription: '',
    webLogo: '',
    webIcon: '',
    pwaTitle: '',
    pwaShortTitle: '',
    pwaIcon: '',
    webPageIcon: '',
    availableIconUrl: '',
    displayDiscount: false,
  })

  const suspendIcon = computed(() => config.value.suspendIcon)
  const availableIconUrl = computed(() => config.value.availableIconUrl)
  const displayDiscount = computed(() => config.value.displayDiscount)
  const carouselMessage = computed(() => config.value.carouselMessage)
  const topDownload = computed(() => config.value.topDownload)
  const bottomDownload = computed(() => config.value.bottomDownload)
  const bottomText = computed(() => config.value.bottomText)
  const bigBanner = computed(() => config.value.bigBanner)
  const smallBanner = computed(() => config.value.smallBanner)
  const popupImage = computed(() => config.value.popupImage)
  const socialMedia = computed(() => config.value.socialMedia)
  const pwaConfig = computed(() => ({
    webTitle: config.value.webTitle,
    webDescription: config.value.webDescription,
    webLogo: config.value.webLogo,
    webIcon: config.value.webIcon,
    webPageIcon: config.value.webPageIcon,
    pwaTitle: config.value.pwaTitle,
    pwaShortTitle: config.value.pwaShortTitle,
    pwaIcon: config.value.pwaIcon,
  }))

  const updateConfig = async () => {
    const preloadManager = useLoadPreload()
    const preloadData = preloadManager.getPreloadData()
    if (preloadData?.homeBanner && useSystemInfo().isInit) {
      Object.assign(config.value, preloadData.homeBanner)
    } else {
      const { code, data } = await api.getHomeConfigs()
      if (code === 1 && data) {
        const enabled = {} as iHomeBannersAndTexts

        Object.entries(data as iHomeBannersAndTexts).forEach(([key, value]) => {
          if (key === 'socialMedia') {
            enabled[key] = value
          } else if (Array.isArray(value)) {
            enabled[key] = value.filter((item) => item.state === 'Enabled')
          } else if (typeof value == 'string') {
            enabled[key] = value
          } else if (typeof value == 'boolean') {
            enabled[key] = value
          } else {
            enabled[key] = value.state === 'Enabled' ? value : null
          }
        })

        Object.assign(config.value, enabled)
      }
    }
  }

  const init = async () => {
    await updateConfig()
  }

  return {
    suspendIcon,
    carouselMessage,
    topDownload,
    bottomDownload,
    bottomText,
    bigBanner,
    smallBanner,
    popupImage,
    socialMedia,
    availableIconUrl,
    displayDiscount,
    pwaConfig,
    init,
  }
})

export const useServico = defineStore('servico', () => {
  const list = ref<iServicoItem[]>([])

  const getServico = async () => {
    const { code, data } = await api.getServicoConfig()
    if (code === 1 && data) {
      return data.filter((item) => item.status == 'Online')
    }

    return []
  }

  const updateList = async () => {
    list.value = await getServico()
  }

  const init = async () => {
    await updateList()
  }

  return { list, updateList, init }
})

export const useAppPwa = defineStore(
  'appPwa',
  () => {
    const installed = ref<boolean>(false)

    const getAppPwa = async () => {
      const { code, data } = await api.getAppPwa()
      if (code === 1) {
        installed.value = data
      }
    }

    const init = async () => {
      installed.value = false
      if (useUserInfo().isLoggedin) await getAppPwa()
    }

    return { installed, getAppPwa, init }
  },
  {
    persist: {
      key: 'appPwa',
    },
  },
)

export const useGameFlowStore = defineStore('gameFlow', () => {
  // 显示  流程类型 和 流程参数
  const isVisible = ref(false)
  const flowType = ref('')
  const flowProps = ref({})

  let resolvePromise: (value: unknown) => void = () => {}

  const show = (type, props = {}) => {
    flowType.value = type
    flowProps.value = { initialData: props } // 统一包装在 initialData 里
    isVisible.value = true

    return new Promise((resolve) => {
      // 将 resolve 函数存起来，以便后续在 finish 或 hide 中调用
      resolvePromise = resolve
    })
  }

  const finish = (data) => {
    isVisible.value = false
    if (resolvePromise) {
      resolvePromise({ confirmed: true, data })
    }
  }

  const hide = () => {
    isVisible.value = false
    if (resolvePromise) {
      resolvePromise({ confirmed: false, data: null })
    }
  }

  return { isVisible, flowType, flowProps, show, finish, hide }
})
